export default __webpack_public_path__ + "static/media/404-landscape.67587774.jpg";